import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import { formatPhoneNumber } from 'react-phone-number-input';

import Box from '@zenbusiness/zui/Box';

import { FIELD_NAMES } from '#client/components/ContactInfoFieldset';
import { buildFieldName } from '#client/utils/form';

function SummaryView({ sectionKey }) {
  const { getValues } = useFormContext();

  // Get current form values to display in the complete state
  const firstName = getValues(buildFieldName(FIELD_NAMES.FIRST_NAME, sectionKey));
  const lastName = getValues(buildFieldName(FIELD_NAMES.LAST_NAME, sectionKey));
  const phone = getValues(buildFieldName(FIELD_NAMES.PHONE, sectionKey));

  return (
    <>
      <Box component="span">{`${firstName} ${lastName}`}</Box>
      <Box component="span">{formatPhoneNumber(phone)}</Box>
    </>
  );
}

SummaryView.propTypes = {
  sectionKey: PropTypes.string.isRequired
};

export default SummaryView;
